<template>
  <div v-if="visible" class="template template-postit">
    <div class="tp-card">
      <h2 class="tp-title">✨ AA 账单</h2>
      <div v-if="discountSummary" class="tp-discount-tag">
      <span>已省 {{ discountSummary.totalDiscount }} 元</span>
    </div>
    <div class="tp-chips">
        <div v-for="(item, i) in resultList" :key="i" class="tp-chip">
          <div class="tp-chip-name">{{ item.name }}</div>
          <div class="tp-chip-pay">实付 {{ item.payAmount.toFixed(2) }}</div>
          <div :class="['tp-chip-amount', item.type === '应退' ? 'green' : 'red']">
            {{ item.type }} {{ item.finalAmount.toFixed(2) }}
          </div>
        </div>
      </div>
      <div class="tp-circle-total">
        <span class="tp-circle-label">总计</span>
        <span class="tp-circle-amount">{{ totalAmount }}</span>
      </div>
      <p class="tp-date">{{ dateStr }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TemplatePostit',
  props: {
    resultList: { type: Array, default: () => [] },
    form: { type: Object, default: () => ({}) },
    visible: { type: Boolean, default: false },
    discountSummary: { type: Object, default: null }
  },
  computed: {
    dateStr() {
      return new Date().toLocaleDateString()
    },
    totalAmount() {
      if (this.discountSummary) return this.discountSummary.finalTotal.toFixed(2)
      return this.resultList.reduce((s, r) => s + r.payAmount, 0).toFixed(2)
    }
  }
}
</script>

<style scoped>
.template-postit {
  width: 375px;
  padding: 16px;
  box-sizing: border-box;
}

.tp-card {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 50%, #fcd34d 100%);
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.tp-title {
  font-size: 22px;
  font-weight: 700;
  text-align: center;
  margin: 0 0 16px;
  color: #92400e;
}

.tp-discount-tag {
  text-align: center;
  margin-bottom: 8px;
}

.tp-discount-tag span {
  display: inline-block;
  background: #15803d;
  color: #fff;
  padding: 3px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.tp-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 16px;
}

.tp-chip {
  flex: 1;
  min-width: 120px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 12px;
  padding: 10px 12px;
  text-align: center;
}

.tp-chip-name {
  font-weight: 700;
  font-size: 14px;
  color: #78350f;
  margin-bottom: 4px;
}

.tp-chip-pay {
  font-size: 12px;
  color: #92400e;
  margin-bottom: 2px;
}

.tp-chip-amount {
  font-weight: 700;
  font-size: 14px;
}

.tp-chip-amount.green {
  color: #15803d;
}

.tp-chip-amount.red {
  color: #dc2626;
}

.tp-circle-total {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  margin: 0 auto 12px;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.tp-circle-label {
  font-size: 11px;
  color: #92400e;
}

.tp-circle-amount {
  font-size: 18px;
  font-weight: 700;
  color: #78350f;
}

.tp-date {
  text-align: center;
  font-size: 11px;
  color: #a16207;
  margin: 0;
}
</style>
